export default function Footer({ businessName, email, phone, location }) {
  return (
    <footer className="bg-[#232323] text-[#DCD9CE] mt-0" data-testid="footer">
      <div className="container-x py-20 grid md:grid-cols-3 gap-12">
        <div>
          <h3 className="font-serif-heading text-2xl text-white mb-4">{businessName}</h3>
          <p className="text-sm text-[#A8A8A8] leading-relaxed max-w-sm">
            Careful, non-destructive restoration for historic and modern memorials.
            Serving families, cemeteries, and historical societies.
          </p>
        </div>
        <div>
          <p className="overline text-[#98604A] mb-4">Contact</p>
          <p className="text-sm leading-relaxed">
            {email}
            <br />
            {phone}
            <br />
            {location}
          </p>
        </div>
        <div>
          <p className="overline text-[#98604A] mb-4">Quick Links</p>
          <ul className="text-sm space-y-2">
            <li><a href="#mission" className="hover:text-white transition">Our Mission</a></li>
            <li><a href="#gallery" className="hover:text-white transition">Before &amp; After</a></li>
            <li><a href="#process" className="hover:text-white transition">Our Process</a></li>
            <li><a href="#quote" className="hover:text-white transition">Request a Quote</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#3a3a3a] py-6">
        <div className="container-x flex flex-col md:flex-row justify-between items-center text-xs text-[#777] gap-2">
          <p>© {new Date().getFullYear()} {businessName}. Restoring dignity, one stone at a time.</p>
          <p>Licensed &amp; insured · D/2 Biological Solution certified</p>
        </div>
      </div>
    </footer>
  );
}
